import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"; // Adjust path if needed
import ChatTime from "./ChatTime";

const ChatCallInfo = ({
  chat,
  currentUser,
  callInfo = {},
  formatDate,
  deleteMessage,
  forwarded = false,
  isGroup = false,
}) => {
  const isCurrentUser = chat?.sender === currentUser?._id;
  const isMissed = callInfo.duration === "00:00";
  const arrowDirection = isCurrentUser ? "up" : "down";

  return (
    <div className="ctext-wrap">
      <div
        className={`ctext-wrap-content ${forwarded ? "border-l-2 border-solid border-blue-300" : ""
          }`}
      >
        <i className={`ri-arrow-left-${arrowDirection}-line text-md text-red-200 float-left`}>
          {callInfo.duration}
        </i>
        <br />
        <p className={`w-full ${isCurrentUser ? "text-left" : "text-right"} pt-1`}>
          {isMissed ? "Missed" : ""} {callInfo.callType} Call {isMissed ? "" : "Ended"}
        </p>
        <ChatTime updatedAt={chat?.updatedAt} formatDate={formatDate} />
      </div>
      <UncontrolledDropdown className="align-self-start">
        <DropdownToggle tag="a">
          <i className="ri-more-2-fill"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => deleteMessage(chat)}>
            Delete <i className="ri-delete-bin-line float-end text-muted"></i>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default ChatCallInfo;
